/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FAQDTO } from '../models/FAQDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomFaqResourceService {
    /**
     * @returns FAQDTO OK
     * @throws ApiError
     */
    public static createFaq1({
        requestBody,
    }: {
        requestBody: FAQDTO,
    }): CancelablePromise<FAQDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/custom/faq/addFaq',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the faq dto requested
     * Retrieves the faq dto requested
     * @returns FAQDTO OK
     * @throws ApiError
     */
    public static getFaq1({
        faqId,
    }: {
        /**
         * The id of the faq requested
         */
        faqId: number,
    }): CancelablePromise<FAQDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/faq/{faqId}',
            path: {
                'faqId': faqId,
            },
        });
    }
    /**
     * Partial update of an existing faq
     * Partial updates given fields of an existing faq
     * @returns FAQDTO OK
     * @throws ApiError
     */
    public static partialUpdateFaq({
        faqId,
        requestBody,
    }: {
        /**
         * The id of the faq requested
         */
        faqId: number,
        requestBody: FAQDTO,
    }): CancelablePromise<FAQDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/custom/faq/{faqId}',
            path: {
                'faqId': faqId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the list of first level FAQs
     * Retrieves a list of all the first level of FAQs
     * @returns FAQDTO OK
     * @throws ApiError
     */
    public static getAllFaqFirstLevel(): CancelablePromise<Array<FAQDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/faq/first-level',
        });
    }
    /**
     * Get the list of first level FAQs filtered by category
     * Retrieves a list of all the first level FAQs filtered by category
     * @returns FAQDTO OK
     * @throws ApiError
     */
    public static getAllFaqFirstLevelByCategory({
        category,
    }: {
        /**
         * The FAQ category to filter by
         */
        category: string,
    }): CancelablePromise<Array<FAQDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/faq/first-level-category/{category}',
            path: {
                'category': category,
            },
        });
    }
    /**
     * Get the list of input FAQ daughters
     * Retrieves a list of all daughters of the FAQ in input
     * @returns FAQDTO OK
     * @throws ApiError
     */
    public static getAllFaqDaughters({
        faqId,
    }: {
        /**
         * The id of the major FAQ
         */
        faqId: number,
    }): CancelablePromise<Array<FAQDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/faq/daughters/{faqId}',
            path: {
                'faqId': faqId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteFaq1({
        id,
    }: {
        /**
         * The id of the faq to delete
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/custom/faq/deleteFaq/{id}',
            path: {
                'id': id,
            },
        });
    }
}
